import { render, staticRenderFns } from "./HtmlLinkCard.vue?vue&type=template&id=ef0827c0&scoped=true&"
import script from "./HtmlLinkCard.vue?vue&type=script&lang=js&"
export * from "./HtmlLinkCard.vue?vue&type=script&lang=js&"
import style0 from "./HtmlLinkCard.vue?vue&type=style&index=0&id=ef0827c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0827c0",
  null
  
)

export default component.exports